import * as React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Slide, Typography, Box, Button } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const SuccessAlert = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <React.Fragment>
        <Dialog open={open} slots={{transition: Transition}} keepMounted onClose={onClose} aria-describedby="alert-dialog-slide-description">
            <DialogTitle>{"Sucesso ao fazer o pedido!"}</DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 1
                    }}
                >
                    <CheckCircleOutlineIcon
                    sx={{
                        fontSize: 80,
                        color: 'green',
                        animation: 'scaleUp 0.5s ease-out'
                    }}
                    />
                    <Typography sx={{ mt: 2 }} variant="body1">
                    Seu pedido foi enviado com sucesso.
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions>
            <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
        
        {/*Animação do icone */}
      <style>
        {` @keyframes scaleUp {
                0%: { transform: scale(0); opacity: 0; }
                100% { transform: scale(1); opacity: 1; }
            }`
        }
      </style>
    </React.Fragment>
  )
}

export default SuccessAlert
